export default __webpack_public_path__ + "media/zurb/img/icons/favicon/favicon-16x16-0ad85147b9d8168cf2624aa32d1fd444.png";